<script setup lang="ts">
import type { ButtonTypeFragment } from '~~layers/.nuxt/graphql-operations'

import { AppLink } from '#components'

const { button, tag } = defineProps<{
  button: ButtonTypeFragment
  tag?: 'a' | 'button' | 'div'
}>()

function getElement(to: string | null | undefined) {
  if (['button', 'div'].includes(tag)) {
    return tag
  }

  return to ? AppLink : 'div'
}

const { loadIcon } = useDynamicIcons()
</script>

<template>
  <component
    :is="getElement(button.Link)"
    v-if="button"
    :to="button.Link"
    :type="tag === 'button' ? 'button' : undefined"
    class="button"
    :class="[`button--${useDash(button.Type)}`, {
      'button--small': button.Small,
    }]"
  >
    <NuxtIcon
      v-if="button.IconLeft"
      :name="loadIcon(button.IconLeft)"
      class="icon"
      :class="[`icon--${useDash(button.IconLeft)}`, {
        'icon:arrow-left': button.IconLeft.includes('arrow_left'),
        'icon:arrow-right': button.IconLeft.includes('arrow_right'),
      }]"
    />
    <span>{{ button.Text }}</span>
    <NuxtIcon
      v-if="button.IconRight"
      :name="loadIcon(button.IconRight)"
      class="icon"
      :class="[`icon--${useDash(button.IconRight)}`, {
        'icon:arrow-left': button.IconRight.includes('arrow_left'),
        'icon:arrow-right': button.IconRight.includes('arrow_right'),
      }]"
    />
  </component>
</template>

<style>
@import url("~layers/components/Strapi/Button.css");
</style>
